var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.show.snow)?_c('Snow',{attrs:{"active":true,"z-index":"2","wind":1,"swing":3,"speed":"m","color":"#ffffff"}}):_vm._e(),(_vm.show.audioPlayer)?_c('AudioPlayer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }